//NPM LIBRARIES
import React, { Fragment, PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import { AUformGroup } from '@gov.au/form';

//COMPONENTS AND UTILITIES
import Heading from '../components/CASA/Heading';
import ProcessMessage from '../components/Portal/ProcessMessage';
import PlainTile from '../components/Portal/PlainTile';

class FormSelectorPage extends PureComponent {
    navigateForm = function (url, params) {
        return url + '?params=' + encodeURIComponent(btoa(JSON.stringify(params)));
    }

    dronerego = () => {
        const url = '/dronerego',
            crumbs = [
                {
                    text: 'myCASA',
                    link: '/forms/dashind'
                }
            ],
            params = {
                'organisationId': '1ad87909-baf0-ea11-a815-000d3a798c61',
                'breadcrumbs': crumbs,
                //'organisationArn': '205328',
                'recordid': 'ee0e9248-b3fc-4e1b-990f-dafbfd701bf3'
            };
        const linksample = this.navigateForm(url, params);
        const name = 'TEST Drone rego (Ind)';

        return this.createFormTile(name, linksample, 'dragonfly')
    }

    IndustryAssist = () => {
        var url = '/industry-assist',
            crumbs = [
                {
                    text: 'myCASA',
                    link: '/forms/formselector'
                }
            ]
        const urlParameters = {
            'organisationId': 'deea0ec9-be07-4bca-ab9c-a195f2cf12e7',
            'breadcrumbs': crumbs,
            'organisationArn': '1131764'
        };

        var linksample = this.navigateForm(url, urlParameters);
        var name = 'Industry Assist';

        return this.createFormTile(name, linksample)
    }

    //certificateManagementApplication = () => {
    //    var url = '/certificate/management',
    //        crumbs = [
    //            {
    //                text: 'myCASA',
    //                link: '/'
    //            }
    //        ]
    //    const urlParameters = {
    //        'organisationId': '950adfba-07ec-ea11-a815-000d3a797c95',
    //        //'recordid': 'c8046206-c04a-4317-a65f-4ff15b52ae59',
    //        // 'recordid': 'a68a2af1-dbba-48e7-8982-118c991f4834',
    //        'breadcrumbs': crumbs,
    //        'organisationArn': '205328'
    //    };

    //    var linksample = this.navigateForm(url, urlParameters);
    //    var name = 'Certificate Management';

    //    return this.createFormTile(name, linksample)
    //}

    MTONotificationOfTrainingOutcomesApplication = () => {
        var url = '/mto-notification-of-training-outcomes',
            crumbs = [
                {
                    text: 'myCASA',
                    link: '/forms/formselector'
                }
            ]
        const urlParameters = {
            'organisationId': 'deea0ec9-be07-4bca-ab9c-a195f2cf12e7',
            'breadcrumbs': crumbs,
            'organisationArn': '1131764'
        };

        var linksample = this.navigateForm(url, urlParameters);
        var name = 'MTO Notification of training outcomes';

        return this.createFormTile(name, linksample)
    }

    digitalLicenceVerificationScanPage = () => {
        var url = "/digitallicence/verification"
        var name = 'Scan licence';

        return this.createFormTile(name, url)
    }

    digitalLicenceVerificationForm = () => {
        var url = "/digitallicence/verification/submit",
            crumbs = [
                {
                    text: 'myCASA',
                    link: '/forms/formselector'
                }
            ],
            params = {
                'breadcrumbs': crumbs,
                'passHash': 'a625bb1d70c8fd2fa2d6d0056250c55993cf1303481a3a8fd33f56c728d4531a'
            };

        var linksample = this.navigateForm(url, params);
        var name = 'Verify licence';

        return this.createFormTile(name, linksample)
    }

    digitalLicenceVerificationPage = () => {
        const url = '/digitallicence/verification/verification-view',
            breadcrumbs = [
                {
                    text: 'myCASA',
                    link: '/formselector'
                }
            ],
            params = {
                'breadcrumbs': breadcrumbs,
                'token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjQ1MzIiLCJsaWNUeXBlIjoiRkNMIiwibmJmIjoxNjAyMTM4ODkxLCJleHAiOjE2MTMxNDI0OTEsImlhdCI6MTYwMjEzODg5MSwiaXNzIjoiQ2l2aWwgQXZpYXRpb24gU2FmZXR5IEF1dGhvcml0eSIsImF1ZCI6IjEyMzQwMCJ9.OjbukxcpNxjwneM2aV98cY_DMWHe3tyVQm0NxU3hJgs',
                'licenceType': 'FCL'
            };

        const linksample = this.navigateForm(url, params);
        const name = 'Verification view';

        return this.createFormTile(name, linksample)
    }

    asicVerificationForm = () => {
        const url = "/licence-view/asic-verification";
        const name = 'Asic verification';

        return this.createFormTile(name, url)
    }

    dronesRenewForm = () => {
        const url = '/dronesrenew'
        const name = 'Renew drone registration';

        return this.createFormTile(name, url, 'Cobra release')
    }

    paymentTestForm = () => {
        const url = '/submissions/payment';
        const name = 'Request Payment';

        return this.createFormTile(name, url, 'Cobra release')
    }

    paymentTestFormOrganisation = () => {
        const url = "/organisation/deea0ec9-be07-4bca-ab9c-a195f2cf12e7/submissions/payment";
        const name = 'Request Payment Organisation';

        return this.createFormTile(name, url, 'Cobra release')
    }

    additionalPaymentTestForm = () => {
        const url = "/organisation/deea0ec9-be07-4bca-ab9c-a195f2cf12e7/submissions/4f06cc82-0a83-ec11-8d21-00224814b1a7/payment";
        const name = 'Request Additional Payment Organisation';

        return this.createFormTile(name, url, "Cobra release")
    }

    aircraftConfirmationPage = () => {
        const url = '/aircraft/confirmation',
            breadcrumbs = [
                {
                    text: 'myCASA',
                    link: '/forms/dashind'
                },
                {
                    text: 'Manage aircraft',
                    link: '/forms/manageaircraftind'
                }
            ],
            params = {
                'breadcrumbs': breadcrumbs,
                'organisationId': 'bcbf10bb-e6ee-e911-a812-000d3a795762',
                'organisationArn': '205328'
            };

        const linksample = this.navigateForm(url, params);
        const name = 'Aircraft Confirmation';

        return this.createFormTile(name, linksample, 'Cobra release')
    }

    dronesRenewForm = () => {
        const url = "/dronesrenewind",
            breadcrumbs = [
                {
                    text: 'myCASA',
                    link: '/forms/dronerego'
                }
            ],
            params = {
                'breadcrumbs': breadcrumbs
            };

        const name = 'Renew Drone Registration';

        const linksample = this.navigateForm(url, params);
        return this.createFormTile(name, linksample, 'Cobra release')
    }

    submissionCancellation = () => {
        const url = "/submissions/9956fc30-a52e-4e36-870c-1990a1ba0ece/cancellation"; //must be In Progress

        const name = 'Cancellation Reason';

        return this.createFormTile(name, url, 'Cobra release')
    }

    submissionCancellationOrganisation = () => {
        const url = '/organisation/e42eea72-db96-e811-a960-000d3ae12152/submissions/121a9c38-1a8d-eb11-b1ac-002248149127/cancellation';

        const name = 'Cancellation Reason Organisation';

        return this.createFormTile(name, url, 'Cobra release')
    }

    createFormTile = (name, link, description) => {
        return (
            <div className='col-lg-12 col-xs-12 col-md-12'>
                <PlainTile
                    name={name}
                    link={link}
                    icon=''
                    messages={[]}
                    description1={description ?? 'Banshee release'}
                    spinner={false}
                />
            </div>
        )
    }

    droneRegistration = () => {
        const url = '/drone-registration';
        const name = 'Drone Registration 2.0';

        return this.createFormTile(name, url, 'dragonfly')
    }

    droneAccreditation = () => {
        const url = '/drone-accreditation';
        const name = 'Drone Accreditation';

        return this.createFormTile(name, url, 'dragonfly');
    }

    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Form Selector</title>
                </MetaTags>

                <ProcessMessage />

                <Heading
                    id="dashboardheading"
                    text="Forms development"
                    showback={false} />

                <br />

                <div className='forms-development-tiles'>
                    <AUformGroup>
                        <h3>Dragonfly</h3>
                        {this.dronerego()}
                        {this.digitalLicenceVerificationScanPage()}
                        {this.digitalLicenceVerificationForm()}
                    </AUformGroup>

                    <AUformGroup>
                        <h3>April release</h3>
                        {this.paymentTestForm()}
                        {this.paymentTestFormOrganisation()}
                        {this.additionalPaymentTestForm()}
                        {this.aircraftConfirmationPage()}
                        {this.dronesRenewForm()}
                        {this.submissionCancellation()}
                        {this.submissionCancellationOrganisation()}
                    </AUformGroup>

                    <AUformGroup>
                        <h3>December release</h3>
                        {this.MTONotificationOfTrainingOutcomesApplication()}
                        {this.digitalLicenceVerificationScanPage()}
                        {this.digitalLicenceVerificationForm()}
                        {this.digitalLicenceVerificationPage()}
                        {this.asicVerificationForm()}
                        {this.dronesRenewForm()}
                    </AUformGroup>

                    <AUformGroup>
                        <h3>August release</h3>
                    </AUformGroup>
                </div>
            </Fragment>
        );

    }
}


export default withRouter(FormSelectorPage);